<input
  *ngIf="!mobile"
  #input
  type="text"
  autocomplete="off"
  class="spot-input"
  data-filter--filters-form-target="singleDay"
  [ngClass]="inputClassNames"
  [ngModel]="value"
  [attr.data-value]="value"
  [attr.data-action]="dataAction"
  [id]="id"
  [name]="name"
  [attr.name]="name"
  [required]="required"
  [disabled]="disabled"
  (input)="changeValueFromInput($event.target.value)"
  (focus)="showDatePicker()"
  (click)="sentCalendarToTopLayer()"
  [attr.data-remote-field-key]="remoteFieldKey"
/>

<ng-container *ngIf="mobile">
  <input
    type="date"
    class="spot-input"
    data-filter--filters-form-target="singleDay"
    [ngClass]="inputClassNames"
    [attr.data-value]="value"
    [attr.data-action]="dataAction"
    [id]="id"
    [name]="name"
    [attr.name]="name"
    [required]="required"
    [disabled]="disabled"
    [ngModel]="value"
    (ngModelChange)="changeValueFromInput($event)"
  />
</ng-container>
